export default __webpack_public_path__ + "static/media/menu.a2908b85.svg";